/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContactDeliveryMethod, EmailMatch } from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { EnumDictionary } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';

import { assign, compact } from 'lodash';
import { CreditorDestinationType } from '../../../resources/model/contact-details-creditor.model';
import { ContactDetailsCommonFormState } from '../../contact-details-common-tab/contact-details-common-form.service';
import { ContactDetailsCreditorCommonFormState } from '../contact-details-creditor-common-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-creditor-destination',
  templateUrl: 'contact-details-creditor-destination.component.html',
  styleUrls: ['contact-details-creditor-destination.component.scss'],
})
export class ContactDetailsCreditorDestinationComponent implements OnInit {
  @Input() destination: CreditorDestinationType;
  @Input() formGroup: FormGroup;

  @Output() methodChange = new EventEmitter<CreditorDestinationType>();

  deliveryMethods: EnumDictionary<ContactDeliveryMethod>;
  emailMatches: EnumDictionary<EmailMatch>;

  methodTitle: string;

  constructor(private route: ContextRoute,
              private translationService: TranslationService,
              private changeDetectorRef: ChangeDetectorRef,
              public commonForm: ContactDetailsCommonFormState,
              public form: ContactDetailsCreditorCommonFormState) {
  }

  get addressText(): string {
    const {
      street1,
      street2,
      city,
      state,
      postcode,
    } = this.commonForm.group.value;

    const index = compact([city, state, postcode]).join(' ');
    return compact([street1, street2, index]).join(', ');
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));

    this.methodTitle = this.translationService.get({
      'orderBy': 'lbl_deliver_order',
      'billingBy': 'lbl_deliver_billing',
      'scheduleBy': 'lbl_deliver_schedule',
    }[this.destination]);
  }

  onUpdateMethod(method: ContactDeliveryMethod): void {
    this.form.updateMethod(this.destination, method);
    // apply angular magic to avoid 'change after check' error
    this.changeDetectorRef.detectChanges();
  }

  onUpdateDifference(match: EmailMatch): void {
    this.form.updateDifference(this.destination, match);
  }
}
